import { type ReactNode } from "react";
import { Link } from "wouter";
import { SectionLabel } from "./section-label";

interface ArticleCardProps {
  image?: string;
  markFallback?: ReactNode;
  number: string;
  category: string;
  categoryColor: string;
  title: string;
  href: string;
}

export function ArticleCard({
  image,
  markFallback,
  number,
  category,
  categoryColor,
  title,
  href,
}: ArticleCardProps) {
  return (
    <Link href={href} className="group cursor-pointer block">
      <div className="relative mb-6 overflow-hidden arch-crop h-80 md:h-96">
        {image ? (
          <>
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 text-transparent"
            />
            <div
              className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500"
              style={{ backgroundColor: categoryColor }}
            />
          </>
        ) : (
          <div className="w-full h-full bg-[#293129] flex items-center justify-center p-8">
            {markFallback}
          </div>
        )}
      </div>
      <SectionLabel number={number} label={category} color={categoryColor} className="mb-4" />
      <h3 className="font-serif text-3xl leading-snug mb-3 group-hover:opacity-70 transition-opacity">
        {title}
      </h3>
    </Link>
  );
}
